/**
 * An alert somebody asked to see by its CAP id: a notification tapped, a
 * `/?at=…&alert=…` link (Phase 9 plan §9.6), or an alert row in the forecast. `MapView` owns the popup, so
 * this is only the request, taken once.
 *
 * Unlike a popup opened from the map menu, this one is not an answer about
 * the layer stack, and changing the layers does not close it.
 */
import type { Alert } from '../api/types'

export const alertLink = $state({
  capId: null as string | null,
  /**
   * The alert as the forecast bundle already holds it, when the request came
   * from an alert row (Phase 10 plan §4.5). The popup shows it at once and
   * still fetches, because the fetch is what says whether it has expired.
   */
  alert: null as Alert | null,
})

export function requestAlert(capId: string, alert: Alert | null = null): void {
  alertLink.alert = alert
  alertLink.capId = capId
}

/** The pending request, cleared. */
export function takeAlertRequest(): { capId: string; alert: Alert | null } | null {
  const capId = alertLink.capId
  const alert = alertLink.alert
  alertLink.capId = null
  alertLink.alert = null
  return capId ? { capId, alert } : null
}
